import React from "react"
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"

import CardItem from "../components/CardItem"


const NewsItem = (props) => 
    <CardItem icon={faInfoCircle} {...props} />

export default NewsItem